(function () {
  var fsOverlay = null;
  var fsState = null;

  function isVideoInFsOverlay(video) {
    return !!(fsState && fsState.video === video && fsOverlay && !fsOverlay.hidden);
  }

  function closeFs() {
    if (!fsState) return;
    var cellInner = fsState.cellInner;
    var video = fsState.video;
    var fsBtn = cellInner.querySelector('.ru-pdp-videos__fs-btn');
    video.muted = true;
    video.setAttribute('muted', '');
    if (fsBtn) {
      cellInner.insertBefore(video, fsBtn);
    } else {
      cellInner.insertBefore(video, cellInner.firstChild);
    }
    cellInner.style.minHeight = '';
    if (fsOverlay) {
      fsOverlay.hidden = true;
      fsOverlay.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
    fsState = null;
    var carousel = cellInner.closest('[data-ru-pdp-videos-carousel]');
    if (carousel && typeof Flickity !== 'undefined' && typeof Flickity.data === 'function') {
      var flickityInstance = Flickity.data(carousel);
      if (flickityInstance) flickityInstance.resize();
    }
  }

  function ensureFsOverlay() {
    if (fsOverlay) return fsOverlay;
    fsOverlay = document.createElement('div');
    fsOverlay.className = 'ru-pdp-videos-fs-overlay';
    fsOverlay.setAttribute('role', 'dialog');
    fsOverlay.setAttribute('aria-modal', 'true');
    fsOverlay.setAttribute('aria-hidden', 'true');
    fsOverlay.hidden = true;
    fsOverlay.innerHTML =
      '<div class="ru-pdp-videos-fs-panel" data-ru-pdp-fs-panel>' +
      '<div class="ru-pdp-videos-fs-stage"></div>' +
      '</div>' +
      '<button type="button" class="ru-pdp-videos-fs-close" data-ru-pdp-fs-close aria-label="Cerrar">&times;</button>';

    fsOverlay.addEventListener('click', function (e) {
      if (e.target.closest('.ru-pdp-videos-fs-panel')) return;
      closeFs();
    });

    fsOverlay.querySelector('[data-ru-pdp-fs-close]').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeFs();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && fsState && fsOverlay && !fsOverlay.hidden) {
        closeFs();
      }
    });

    document.body.appendChild(fsOverlay);

    var closeBtn = fsOverlay.querySelector('[data-ru-pdp-fs-close]');
    var i18nSrc = document.querySelector('[data-ru-pdp-videos-carousel][data-i18n-fs-close]');
    if (closeBtn && i18nSrc) {
      var label = i18nSrc.getAttribute('data-i18n-fs-close');
      if (label) closeBtn.setAttribute('aria-label', label);
    }

    return fsOverlay;
  }

  function openFullscreen(cellInner) {
    var video = cellInner.querySelector('video');
    if (!video) return;
    var overlay = ensureFsOverlay();
    var stage = overlay.querySelector('.ru-pdp-videos-fs-stage');
    var h = cellInner.offsetHeight;
    if (h > 0) {
      cellInner.style.minHeight = h + 'px';
    }
    fsState = {
      cellInner: cellInner,
      video: video,
    };
    stage.appendChild(video);
    video.muted = false;
    video.removeAttribute('muted');
    video.volume = 1;
    if (video.paused) {
      video.play().catch(function () {});
    }
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function prepareVideoElement(video) {
    video.removeAttribute('controls');
    video.controls = false;
    try {
      video.disablePictureInPicture = true;
    } catch (e) {}
    if (video.controlsList) {
      try {
        video.controlsList.add('nodownload', 'noremoteplayback', 'noplaybackrate');
      } catch (e) {}
    }
  }

  function setupRuPdpVideoCell(cellInner, resizeCarousel) {
    if (cellInner.dataset.ruPdpVideoCellInit === '1') return;
    cellInner.dataset.ruPdpVideoCellInit = '1';

    var video = cellInner.querySelector('video');
    var playBtn = cellInner.querySelector('.custom-play-btn');
    var fsBtn = cellInner.querySelector('.ru-pdp-videos__fs-btn');
    if (!video || !playBtn) return;

    var autoplayPreview = cellInner.classList.contains('ru-pdp-videos__cell-inner--autoplay-preview');

    prepareVideoElement(video);

    if (autoplayPreview) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.play().catch(function () {});
    }

    playBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (autoplayPreview && cellInner.dataset.ruPdpUserUnmuted !== '1') {
        cellInner.dataset.ruPdpUserUnmuted = '1';
        video.currentTime = 0;
        video.muted = false;
        video.volume = 1;
        try {
          video.loop = false;
        } catch (err) {}
        video.removeAttribute('loop');
        video.play().catch(function () {});
        playBtn.style.display = 'none';
        return;
      }
      if (video.paused) {
        video.play();
        playBtn.style.display = 'none';
      }
    });

    video.addEventListener('click', function (e) {
      if (e.target.closest('.ru-pdp-videos__fs-btn')) return;
      if (isVideoInFsOverlay(video)) {
        e.preventDefault();
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
        return;
      }
      if (!video.paused) {
        video.pause();
        playBtn.style.display = '';
      }
    });

    video.addEventListener('pause', function () {
      if (cellInner.contains(video)) {
        playBtn.style.display = '';
      }
    });
    video.addEventListener('play', function () {
      if (!cellInner.contains(video)) return;
      if (autoplayPreview && cellInner.dataset.ruPdpUserUnmuted !== '1') {
        playBtn.style.display = '';
        return;
      }
      playBtn.style.display = 'none';
    });

    if (fsBtn) {
      fsBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        openFullscreen(cellInner);
      });
    }

    if (resizeCarousel) {
      video.addEventListener('loadedmetadata', resizeCarousel);
      video.addEventListener('load', resizeCarousel);
    }
  }

  function ruPdpIsMobileViewport() {
    return window.matchMedia('(max-width: 767.98px)').matches;
  }

  function ruPdpShouldUseFlickity(wrap) {
    var n = parseInt(wrap.getAttribute('data-ru-pdp-video-count'), 10) || 0;
    if (ruPdpIsMobileViewport()) return n > 2;
    return n > 4;
  }

  function makeResizeHandler(wrap) {
    return function () {
      if (typeof Flickity === 'undefined' || typeof Flickity.data !== 'function') return;
      var f = Flickity.data(wrap);
      if (f) f.resize();
    };
  }

  function ensureCellsBound(wrap) {
    var resize = makeResizeHandler(wrap);
    wrap.querySelectorAll('.ru-pdp-videos__cell-inner').forEach(function (inner) {
      setupRuPdpVideoCell(inner, resize);
    });
  }

  function teardownFlickityLoadListeners(wrap) {
    if (!wrap._ruPdpOnLoad) return;
    window.removeEventListener('load', wrap._ruPdpOnLoad);
    wrap.querySelectorAll('video, iframe').forEach(function (m) {
      m.removeEventListener('load', wrap._ruPdpOnLoad);
      m.removeEventListener('loadedmetadata', wrap._ruPdpOnLoad);
    });
    wrap._ruPdpOnLoad = null;
  }

  function syncRuPdpCarousels() {
    if (typeof Flickity === 'undefined') return;
    document.querySelectorAll('[data-ru-pdp-videos-carousel]').forEach(function (wrap) {
      var want = ruPdpShouldUseFlickity(wrap);
      var inst = Flickity.data(wrap);
      wrap.classList.toggle('ru-pdp-videos__carousel--static', !want);

      if (!want && inst) {
        teardownFlickityLoadListeners(wrap);
        inst.destroy();
      }

      inst = Flickity.data(wrap);

      if (want && !inst) {
        new Flickity(wrap, {
          cellAlign: 'left',
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
          imagesLoaded: true,
        });
        wrap._ruPdpOnLoad = makeResizeHandler(wrap);
        window.addEventListener('load', wrap._ruPdpOnLoad);
        setTimeout(wrap._ruPdpOnLoad, 150);
        setTimeout(wrap._ruPdpOnLoad, 600);
        wrap.querySelectorAll('video, iframe').forEach(function (m) {
          m.addEventListener('load', wrap._ruPdpOnLoad);
          m.addEventListener('loadedmetadata', wrap._ruPdpOnLoad);
        });
      } else if (want && Flickity.data(wrap)) {
        Flickity.data(wrap).resize();
      }

      ensureCellsBound(wrap);
    });
  }

  var resizeDebounce;
  var resizeBound = false;
  function onResize() {
    clearTimeout(resizeDebounce);
    resizeDebounce = setTimeout(function () {
      if (typeof Flickity !== 'undefined') syncRuPdpCarousels();
    }, 150);
  }

  function tryInit() {
    if (typeof Flickity === 'undefined') return false;
    syncRuPdpCarousels();
    return true;
  }

  function bindViewportResizeOnce() {
    if (resizeBound) return;
    resizeBound = true;
    window.addEventListener('resize', onResize);
  }

  function boot() {
    if (tryInit()) {
      bindViewportResizeOnce();
      return;
    }
    var attempts = 0;
    var id = setInterval(function () {
      attempts++;
      if (tryInit() || attempts > 40) {
        clearInterval(id);
        if (typeof Flickity !== 'undefined') bindViewportResizeOnce();
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    tryInit();
  });
})();
